// Tracks whether any Firestore read is currently in flight, so the UI can say
// "still loading" without every page having to implement its own state.
//
// Most pages in this app fire their fetches from componentDidMount without
// awaiting them and render immediately, which leaves an empty table on screen
// with nothing to explain why (the Invoice list is the clearest example: it
// asks for a page of lots and renders whatever it holds meanwhile). Rather
// than add a `loading` flag to 138 components, reads are counted centrally —
// see the instrumentation in firebase/firebase.utils.js — and one indicator in
// the app shell reflects the count.

let active = 0;
const listeners = new Set();

const notify = () => {
  const busy = active > 0;
  listeners.forEach((listener) => {
    try {
      listener(busy);
    } catch (error) {
      console.error("Activity listener failed:", error);
    }
  });
};

export const isBusy = () => active > 0;

/** Subscribe to busy/idle changes. Returns an unsubscribe function. */
export const subscribeToActivity = (listener) => {
  listeners.add(listener);
  listener(active > 0);
  return () => listeners.delete(listener);
};

/**
 * Counts a promise as in-flight for as long as it is pending. Returns the
 * same promise, so it is transparent to callers — including their rejections,
 * which must keep propagating exactly as before.
 */
export const trackActivity = (promise) => {
  active += 1;
  notify();
  return promise.finally(() => {
    active -= 1;
    notify();
  });
};
